import React from 'react'

export default function Bookmark() {
    const book=JSON.parse(localStorage.getItem("bookmarks")) || []
  return (
    <div className='Note'>
        {book.map(el=>{
            return(
                <div >
                    <h2>{el.title}</h2>
                    <p>{el.describe}</p>
                    <h4>{el.date}</h4>
                </div>
                
            )
        })}
    </div>
  )
}
